module.exports = __webpack_public_path__ + "img/224.56040640.jpg";